import { Component, OnInit } from '@angular/core';
import { routeAnimations } from '../../core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [routeAnimations]

})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
